import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const FreeSpins = lazyRouteComponent(() => import('../../pages/profile/free-spins'))

export const freeSpinsRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'free-spins',
  component: FreeSpins,
})
